import { TweenMax } from 'gsap';

const fn = {
    init: () => {
        if ($('.custom-cursor__overlay').length) {
            // / cursor /
            var cursor = $('.custom-cursor__overlay .cursor'),
                follower = $('.custom-cursor__overlay .cursor-follower');

            var posX = 0,
                posY = 0;

            var mouseX = 0,
                mouseY = 0;

            TweenMax.to({}, 0.016, {
                repeat: -1,
                onRepeat: function () {
                    posX += (mouseX - posX) / 9;
                    posY += (mouseY - posY) / 9;

                    TweenMax.set(follower, {
                        css: {
                            left: posX - 22,
                            top: posY - 22,
                        },
                    });

                    TweenMax.set(cursor, {
                        css: {
                            left: mouseX,
                            top: mouseY,
                        },
                    });
                },
            });

            $(document).on('mousemove', function (e) {
                var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                mouseX = e.pageX;
                mouseY = e.pageY - scrollTop;
            });
            $('button, a').on('mouseenter', function () {
                cursor.addClass('active');
                follower.addClass('active');
            });
            $('button, a').on('mouseleave', function () {
                cursor.removeClass('active');
                follower.removeClass('active');
            });
            $('.custom-cursor__overlay').on('mouseenter', function () {
                cursor.addClass('close-cursor');
                follower.addClass('close-cursor');
            });
            $('.custom-cursor__overlay').on('mouseleave', function () {
                cursor.removeClass('close-cursor');
                follower.removeClass('close-cursor');
            });
        }
    }
}

export default {
    can: () => true,
    run: fn.init,
};
